function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 16px;\n  height: 16px;\n  color: ", ";\n  position: absolute;\n  right: 30px;\n  top: 16px;\n  cursor: pointer;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin: 16px 0px;\n  cursor: pointer;\n  .ctaContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    .cancelCta {\n      width: 5rem;\n      margin-right: 8px;\n      text-align: right;\n    }\n    .saveCta {\n      width: 5rem;\n      text-align: right;\n    }\n  }\n  &.full {\n    width: 100%;\n    padding: 8px 30px;\n    position: fixed;\n    right: 1%;\n    bottom: 0px;\n    background: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin: 16px 0px;\n  &.full {\n    padding: 16px 30px;\n    width: 90%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 50px;\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  &.full {\n    padding: 16px 30px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 30%;\n  background-color: ", ";\n  position: absolute;\n  padding: 16px 30px 16px 30px;\n  top: 50%;\n  left: 50%;\n  z-index: 1200;\n  transform: translate(-50%, -50%);\n  border-radius: 4px;\n  &.small {\n    width: 30%;\n  }\n  &.medium {\n    width: 60%;\n  }\n  &.large {\n    width: 90%;\n  }\n  &.full {\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1200;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CustomButton from '../../atoms/CustomButton';
import { defaultTheme } from '../../../utils';
var Overlay = styled.div(_templateObject());
var ModalContainer = styled.div(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.primaryHoverColor;
});
var ModalTitle = styled.div(_templateObject3(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.typeScale.header2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.primaryFontWeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.textColor;
});
var ModalBody = styled.div(_templateObject4());
var ModalFooter = styled.div(_templateObject5(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.primaryColor;
});
var CloseButton = styled.span(_templateObject6(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.status.cancel;
});
var modalVariant = {
  initial: {
    opacity: 0
  },
  isOpen: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
var containerVariant = {
  initial: {
    top: '-50%',
    transition: {
      type: 'spring'
    }
  },
  isOpen: {
    top: '50%'
  },
  exit: {
    top: '-50%'
  }
};

var Modal = function Modal(_ref7) {
  var handleClose = _ref7.handleClose,
      handleCta = _ref7.handleCta,
      children = _ref7.children,
      isOpen = _ref7.isOpen,
      title = _ref7.title,
      size = _ref7.size,
      hasFooter = _ref7.hasFooter,
      ctaPrimary = _ref7.ctaPrimary,
      ctaSecondary = _ref7.ctaSecondary,
      rest = _objectWithoutPropertiesLoose(_ref7, ["handleClose", "handleCta", "children", "isOpen", "title", "size", "hasFooter", "ctaPrimary", "ctaSecondary"]);

  var isFullSize = function isFullSize() {
    return size === 'full';
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement(Overlay, {
    initial: 'initial',
    animate: 'isOpen',
    exit: 'exit',
    variants: modalVariant
  }, /*#__PURE__*/React.createElement(ModalContainer, _extends({
    variants: containerVariant,
    className: size
  }, rest), size && !isFullSize() && /*#__PURE__*/React.createElement(CloseButton, _extends({
    onClick: handleClose
  }, rest), "\u2715"), /*#__PURE__*/React.createElement(ModalTitle, _extends({
    className: isFullSize() ? size : ''
  }, rest), title), /*#__PURE__*/React.createElement(ModalBody, _extends({
    className: isFullSize() ? size : ''
  }, rest), children), (hasFooter || isFullSize()) && /*#__PURE__*/React.createElement(ModalFooter, _extends({
    className: isFullSize() ? size : ''
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "ctaContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cancelCta"
  }, /*#__PURE__*/React.createElement(CustomButton, _extends({
    variant: isFullSize() ? 'contained' : 'text',
    modifiers: !isFullSize() ? ['textCancelButton'] : null,
    onClick: handleClose
  }, rest), ctaSecondary)), /*#__PURE__*/React.createElement("div", {
    className: "saveCta"
  }, /*#__PURE__*/React.createElement(CustomButton, {
    variant: isFullSize() ? 'contained' : 'text',
    modifiers: !isFullSize() ? ['textSaveButton'] : null,
    onClick: handleCta
  }, ctaPrimary)))))));
};

Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.string,
  hasFooter: PropTypes.bool,
  ctaPrimary: PropTypes.string,
  ctaSecondary: PropTypes.string,
  children: PropTypes.node,
  handleClose: PropTypes.func,
  handleCta: PropTypes.func
} : {};
Modal.defaultProps = {
  isOpen: false,
  title: '',
  size: 'small',
  hasFooter: false,
  ctaPrimary: '',
  ctaSecondary: '',
  handleClose: function handleClose() {},
  handleCta: function handleCta() {},
  theme: defaultTheme
};
export default Modal;